const initialState = {
    data: {
        company: {
            companyPermission: {},
            selectedTags: [],
            topMarkets: [{}, {}, {}],
            productCategories: [{}],
            majorCustomers: [],
            companyCertifications: [{}],
            deletedAuditCerts: [],
            privacySettings: {},
            tags: [{}],
        },
        supplier: {
            selectedTags: [],
            topMarkets: [{}, {}, {}],
            productCategories: [{}],
            majorCustomers: [],
            supplierCertifications: [{}],
            supplierRating: {},
            deletedAuditCerts: [],
            privacySettings: {},
            supplierId: "",
            tags: [{}],
        },
    },
    status: "uninitialized",
};

export default initialState;